import React from "react";
import { useLang } from "../i18n";

export default function Stratflow() {
  const { t } = useLang();
  return (
    <section id="method" data-testid="method-section" className="relative overflow-hidden border-t border-gt-cream/8">
      {/* darker stripe to make the section stand out */}
      <div className="absolute inset-0" style={{ backgroundColor: "#071614" }} />
      <div className="gt-grain absolute inset-0" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-36">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <div className="section-eyebrow mb-6">
              <span className="gt-eyebrow">{t.method.eyebrow}</span>
            </div>
            <h2 className="gt-display text-gt-cream text-4xl md:text-6xl lg:text-7xl">
              {t.method.title_a} <span className="block text-gt-cream/55 gt-display-light">{t.method.title_em}</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-base md:text-lg text-gt-ink/75 leading-relaxed">{t.method.subtitle}</p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-gt-cream/8">
          {t.method.steps.map((s, idx) => (
            <div key={s.n} data-testid={`method-step-${idx + 1}`} className="bg-gt-bg p-8 md:p-12 min-h-[320px] flex flex-col">
              <div className="font-display text-7xl text-gt-cream/35 leading-none mb-10">{s.n}</div>
              <h3 className="font-display text-gt-cream text-2xl md:text-[1.7rem] uppercase leading-tight mb-4">{s.title}</h3>
              <p className="text-sm md:text-base text-gt-ink/70 leading-relaxed mt-auto">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
